import cx from 'classnames'
import styles from './style.styl'

export const SectionItem = ({ title, description, children, className }) => (
  <div className={cx(styles.SectionItem, className)}>
    {title &&
      <span className="title">
        {title}
      </span>
    }

    {description &&
      <div className="description">
        {description}
      </div>
    }

    <div className="content">
      {children}
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/scripts/components/shared/Section/index.js